import { styled, css } from 'styled-components';
import { Button } from '@template/components/Button/styles.ts';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  height: fit-content;
`;

export const Wrapper = styled.div<{
  $alternativeStyling?: boolean;
  $width: number;
  $height: number;
  $gap: number;
  $borderRadius: number;
  $reverse?: boolean;
}>`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: clip;
  ${({
    theme,
    $width,
    $height,
    $alternativeStyling,
    $gap,
    $borderRadius,
    $reverse,
  }) => css`
    grid-column: span ${$width};
    grid-row: span ${$height};
    background: ${$alternativeStyling
      ? theme.colors.default[900]
      : theme.colors.default[100]};
    color: ${$alternativeStyling
      ? theme.colors.default[100]
      : theme.colors.default.default};
    border-radius: ${$gap ? `${$borderRadius}px` : 0};
    outline: 1px solid
      ${$alternativeStyling
        ? theme.colors.default[900]
        : theme.colors.default[200]};
    flex-direction: ${$reverse ? 'column-reverse' : 'column'};

    ${$reverse &&
    css`
      ${Content} {
        justify-content: flex-end;
        margin-top: auto;
      }
    `}
  `}
`;

export const ContentWrapper = styled.div`
  padding: 32px;
  flex: 1;
  display: flex;
  flex-direction: column;

  ${Button} {
    margin-top: auto;
  }
`;
